// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__hnD1P","rotate":"style_rotate__HeqxV","ball1":"style_ball1__s1PRR","ball2":"style_ball2__ASWVM"};